import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { SettingsField } from '../../../components/Settings/ClearableInput'
import SettingsCard from '../../../components/Settings/SettingsCard'
import { charityAddress } from '../../../lib/address'
import styles from './CharityOrganizationCard.module.scss'

function ReadOnlyValue({ id, label, value }) {
  return (
    <div className="col-md-6">
      <SettingsField label={label} htmlFor={id}>
        <div className={styles.readOnly} id={id}>
          {value || '—'}
        </div>
      </SettingsField>
    </div>
  )
}

ReadOnlyValue.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.string,
}

export default function CharityOrganizationCard({ charity }) {
  const { t } = useTranslation()
  const irsAddress = charityAddress(charity)

  return (
    <SettingsCard
      icon="hands-heart"
      title={t('charities.settings.organization_title')}
    >
      <div className={styles.irsNote} role="note">
        <strong>{t('charities.settings.irs_block_strong')}</strong>{' '}
        {t('charities.settings.irs_block_text')}
      </div>

      <div className="row g-3">
        <ReadOnlyValue
          id="organization_name"
          label={t('charities.settings.organization_name')}
          value={charity?.organization_name}
        />
        <ReadOnlyValue
          id="also_known_as"
          label={t('charities.settings.also_known_as')}
          value={charity?.also_known_as}
        />
        <ReadOnlyValue
          id="ein"
          label={t('charities.settings.ein')}
          value={charity?.ein}
        />
        <ReadOnlyValue
          id="website_url"
          label={t('charities.settings.website')}
          value={charity?.website_url}
        />
        <ReadOnlyValue
          id="irs_address"
          label={t('charities.settings.address')}
          value={irsAddress}
        />
        <div className="col-12">
          <SettingsField
            label={t('charities.settings.mission')}
            htmlFor="mission"
          >
            <div className={styles.readOnly} id="mission">
              {charity?.mission || '—'}
            </div>
          </SettingsField>
        </div>
      </div>
    </SettingsCard>
  )
}

CharityOrganizationCard.propTypes = {
  charity: PropTypes.object,
}
